import type { PosConnectionStatus, S2SAuth, S2SConfig, S2SIntegrationType } from '@gcv/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { DispensariesApi } from 'api';
import { DISPENSARY_S2S_CONFIG_KEY } from 'tanstack-hooks/keys';

export function useUpdateDispensaryS2sConfig(dispensaryId: string) {
  const dispensaryApi = new DispensariesApi();
  const queryClient = useQueryClient();
  const { mutateAsync: updateS2sConfig, isPending: isSetDispensaryS2sConfigPending } = useMutation({
    mutationKey: [DISPENSARY_S2S_CONFIG_KEY],
    mutationFn: async (value: {
      s2sType: S2SIntegrationType;
      auth: S2SAuth;
      status?: PosConnectionStatus;
      enabled?: boolean;
    }) => {
      return await dispensaryApi.setS2sConfig(
        dispensaryId,
        value.s2sType,
        value.auth,
        value.status,
        value.enabled
      );
    },
    onSuccess: (data) => {
      // if successful, set the data. If auth fails, a different object comes back
      if ((data as S2SConfig<S2SAuth>).s2sType) {
        queryClient.setQueryData([DISPENSARY_S2S_CONFIG_KEY, dispensaryId], data);
      }
    }
  });
  return {
    updateS2sConfig,
    isSetDispensaryS2sConfigPending
  };
}
